import tw, { styled } from 'twin.macro';

const TextLink = styled.a([
  tw`border-b border-gray-700 hover:(text-darkred border-red)`,
]);

export default TextLink;
